import { render, staticRenderFns } from "./TicketGetView.vue?vue&type=template&id=0a511ba5"
import script from "./TicketGetView.vue?vue&type=script&lang=js"
export * from "./TicketGetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports